(function () {
  var setupLinks = [
    { label: 'English', href: 'https://www.youtube.com/watch?v=1tPmcawP_SU' },
    { label: '\u7b80\u4f53', href: 'https://www.youtube.com/watch?app=desktop&v=IsdpCuViBgQ&ra=m' },
    { label: '\u7e41\u9ad4', href: 'https://www.youtube.com/watch?app=desktop&v=E49OGOVieQg&ra=m' }
  ];

  function localeKind() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('zh-tw') === 0 || lang.indexOf('zh-hant') === 0) return 'tc';
    if (lang.indexOf('zh-cn') === 0 || lang.indexOf('zh-hans') === 0) return 'sc';
    return 'en';
  }

  function localizedPath(path) {
    var kind = localeKind();
    if (!path || kind === 'en') return path;
    if (path.indexOf('/') !== 0 || path.indexOf('//') === 0) return path;
    if (path.indexOf('/cdn/') === 0 || path.indexOf('/apps/') === 0) return path;

    var prefix = kind === 'tc' ? '/zh-hant' : '/zh-hans';
    if (path === prefix || path.indexOf(prefix + '/') === 0) return path;
    return prefix + path;
  }

  function appendRichText(parent, node) {
    if (!node) return;

    if (node.type === 'text') {
      var textNode = document.createTextNode(node.value || '');
      if (node.bold) {
        var strong = document.createElement('strong');
        strong.appendChild(textNode);
        parent.appendChild(strong);
      } else {
        parent.appendChild(textNode);
      }
      return;
    }

    var tag = 'div';
    if (node.type === 'paragraph') tag = 'p';
    if (node.type === 'heading') tag = 'h' + Math.min(Math.max(Number(node.level) || 3, 2), 4);
    if (node.type === 'list') tag = node.listType === 'ordered' ? 'ol' : 'ul';
    if (node.type === 'list-item') tag = 'li';

    var el = document.createElement(tag);
    (node.children || []).forEach(function (child) {
      appendRichText(el, child);
    });
    parent.appendChild(el);
  }

  function parseRichTextJson(text) {
    var trimmed = text.trim();
    if (trimmed.indexOf('{"type":"root"') !== 0) return null;
    try {
      return JSON.parse(trimmed);
    } catch (error) {
      return null;
    }
  }

  function fragmentFromRichText(data) {
    var fragment = document.createDocumentFragment();
    (data.children || []).forEach(function (child) {
      appendRichText(fragment, child);
    });
    return fragment;
  }

  function repairRichTextJson(root) {
    root.querySelectorAll('p, div, span, strong, h1, h2, h3, h4, h5, li').forEach(function (el) {
      if (el.children.length > 0) return;
      var data = parseRichTextJson(el.textContent || '');
      if (data) el.replaceWith(fragmentFromRichText(data));
    });

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var data = parseRichTextJson(node.nodeValue || '');
      if (data && node.parentNode) node.parentNode.replaceChild(fragmentFromRichText(data), node);
    });
  }

  function setLinkedText(el, text, href) {
    el.innerHTML = '';
    var link = document.createElement('a');
    link.href = localizedPath(href);
    link.textContent = text;
    el.appendChild(link);
  }

  function localizeInternalLinks() {
    if (localeKind() === 'en') return;
    document.querySelectorAll('a[href^="/"]').forEach(function (link) {
      var href = link.getAttribute('href');
      link.setAttribute('href', localizedPath(href));
    });
  }

  function makeSetupGuideText(kind) {
    var prefix = kind === 'sc' ? 'Watch2Care Vital \u8bbe\u7f6e\u6307\u5357 ' : kind === 'tc' ? 'Watch2Care Vital \u8a2d\u5b9a\u6307\u5357 ' : 'Watch2Care Vital Set Up Guide ';
    var fragment = document.createDocumentFragment();
    fragment.appendChild(document.createTextNode(prefix));
    setupLinks.forEach(function (item, index) {
      if (index > 0) fragment.appendChild(document.createTextNode(' '));
      fragment.appendChild(document.createTextNode('('));
      var link = document.createElement('a');
      link.href = item.href;
      link.textContent = item.label;
      fragment.appendChild(link);
      fragment.appendChild(document.createTextNode(')'));
    });
    return fragment;
  }

  function appendFooterRow(parent, kind, type) {
    var row = document.createElement('h5');
    if (type === 'setup') {
      row.appendChild(makeSetupGuideText(kind));
    } else {
      var label = kind === 'sc' ? '\u63d0\u4ea4\u64a4\u9500\u7533\u8bf7' : kind === 'tc' ? '\u63d0\u4ea4\u64a4\u92b7\u7533\u8acb' : 'Submit Withdrawal';
      setLinkedText(row, label, '/pages/eu-withdrawal-form');
    }
    parent.appendChild(row);
  }

  function repairFooterLinks() {
    var footer = document.querySelector('footer');
    if (!footer) return;

    var kind = localeKind();
    var linkMap = {
      '\u95dc\u65bc\u6211\u5011': '/pages/about-us',
      '\u5173\u4e8e\u6211\u4eec': '/pages/about-us',
      '\u806f\u7d61\u6211\u5011': '/pages/contact',
      '\u8054\u7cfb\u6211\u4eec': '/pages/contact',
      '\u5e38\u898b\u554f\u984c (FAQ)': '/pages/faq',
      '\u5e38\u89c1\u95ee\u9898 (FAQ)': '/pages/faq',
      '\u914d\u9001\u8cc7\u8a0a': '/pages/delivery-information',
      '\u914d\u9001\u4fe1\u606f': '/pages/delivery-information',
      '\u9000\u8ca8/\u7dad\u4fee\u653f\u7b56': '/pages/returns-refunds',
      '\u9000\u8d27/\u7ef4\u4fee\u653f\u7b56': '/pages/returns-refunds',
      '\u6211\u5011\u7684\u5408\u4f5c\u5925\u4f34\u8207\u9858\u666f\u5bb6': '/pages/partners',
      '\u6211\u4eec\u7684\u5408\u4f5c\u4f19\u4f34\u4e0e\u613f\u666f\u5bb6': '/pages/partners',
      'Delivery Information': '/pages/delivery-information',
      'Returns / Repairs Policies': '/pages/returns-refunds',
      'Submit Withdrawl': '/pages/eu-withdrawal-form',
      'Submit Withdrawal': '/pages/eu-withdrawal-form'
    };

    footer.querySelectorAll('h5, p, span').forEach(function (el) {
      var text = el.textContent.trim();
      if (text === 'Submit Withdrawl') {
        setLinkedText(el, 'Submit Withdrawal', '/pages/eu-withdrawal-form');
        return;
      }
      if (!el.querySelector('a') && linkMap[text]) setLinkedText(el, text, linkMap[text]);
    });

    var anchorLabel = kind === 'en' ? 'About Us' : kind === 'tc' ? '\u95dc\u65bc\u6211\u5011' : '\u5173\u4e8e\u6211\u4eec';
    var anchorRow = Array.prototype.find.call(footer.querySelectorAll('h5, p'), function (el) {
      return (el.textContent || '').trim() === anchorLabel;
    });
    var footerTextBlock = anchorRow ? anchorRow.parentElement : null;
    if (!footerTextBlock) return;

    var allFooterText = footerTextBlock.textContent || '';
    var guideLabel = kind === 'en' ? 'Set Up Guide' : kind === 'tc' ? '\u8a2d\u5b9a\u6307\u5357' : '\u8bbe\u7f6e\u6307\u5357';
    if (allFooterText.indexOf('Watch2Care Vital') === -1 || allFooterText.indexOf(guideLabel) === -1) appendFooterRow(footerTextBlock, kind, 'setup');
    if (allFooterText.indexOf('Submit Withdrawal') === -1 && allFooterText.indexOf('\u63d0\u4ea4\u64a4\u92b7\u7533\u8acb') === -1 && allFooterText.indexOf('\u63d0\u4ea4\u64a4\u9500\u7533\u8bf7') === -1) appendFooterRow(footerTextBlock, kind, 'withdrawal');
  }

  function removeDuplicateWithdrawalContent() {
    if (window.location.pathname.indexOf('/pages/returns-refunds') === -1) return;
    var rte = document.querySelector('.l2c-info-rte');
    if (!rte) return;

    var children = Array.prototype.slice.call(rte.children);
    var removing = false;
    children.forEach(function (child) {
      var text = (child.textContent || '').trim();
      var isOldWithdrawalStart = text.indexOf('Right of Withdrawal') === 0 || text.indexOf('\u64a4\u92b7\u6b0a') === 0 || text.indexOf('\u64a4\u9500\u6743') === 0;
      var isWarrantyStart = text.indexOf('LINK2CARE') !== -1 || text.indexOf('WATCH2CARE') !== -1 || text.indexOf('Warranty Terms') !== -1 || text.indexOf('\u4fdd\u4fee\u689d\u6b3e') !== -1 || text.indexOf('\u4fdd\u4fee\u6761\u6b3e') !== -1;

      if (isOldWithdrawalStart) removing = true;
      if (removing && isWarrantyStart && !isOldWithdrawalStart) removing = false;
      if (removing) child.remove();
    });
  }

  function replaceTextNodes(root, replacements) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var value = node.nodeValue;
      Object.keys(replacements).forEach(function (key) {
        if (value.indexOf(key) !== -1) value = value.split(key).join(replacements[key]);
      });
      node.nodeValue = value;
    });
  }

  function localizeWithdrawalForm() {
    if (window.location.pathname.indexOf('/pages/eu-withdrawal-form') === -1) return;
    var kind = localeKind();
    if (kind === 'en') return;

    var tc = {
      'Withdrawal form': '\u64a4\u92b7\u7533\u8acb\u8868',
      '1 · Details': '1 · \u8cc7\u6599',
      '1 Â· Details': '1 · \u8cc7\u6599',
      '2 · Items': '2 · \u5546\u54c1',
      '2 Â· Items': '2 · \u5546\u54c1',
      '3 · Confirmed': '3 · \u5df2\u78ba\u8a8d',
      '3 Â· Confirmed': '3 · \u5df2\u78ba\u8a8d',
      'Your details': '\u60a8\u7684\u8cc7\u6599',
      'Please enter your email and order number. The merchant uses this data for manual matching.': '\u8acb\u8f38\u5165\u60a8\u7684\u96fb\u90f5\u5730\u5740\u53ca\u8a02\u55ae\u7de8\u865f\u3002\u5546\u6236\u6703\u4f7f\u7528\u9019\u4e9b\u8cc7\u6599\u4f5c\u4eba\u5de5\u6838\u5c0d\u3002',
      'Name': '\u59d3\u540d',
      'Optional: your name': '\u9078\u586b\uff1a\u60a8\u7684\u59d3\u540d',
      'Order number': '\u8a02\u55ae\u7de8\u865f',
      'Required field. Please enter the order number as shown in your confirmation.': '\u5fc5\u586b\u6b04\u4f4d\u3002\u8acb\u8f38\u5165\u78ba\u8a8d\u901a\u77e5\u4e0a\u986f\u793a\u7684\u8a02\u55ae\u7de8\u865f\u3002',
      'Email': '\u96fb\u90f5',
      'Your confirmation will be sent to this address.': '\u78ba\u8a8d\u901a\u77e5\u5c07\u767c\u9001\u81f3\u6b64\u96fb\u90f5\u5730\u5740\u3002',
      'Our Privacy Policy applies.': '\u6211\u5011\u7684\u79c1\u96b1\u653f\u7b56\u9069\u7528\u3002',
      'Privacy Policy': '\u79c1\u96b1\u653f\u7b56',
      'Continue': '\u7e7c\u7e8c'
    };
    var sc = {
      'Withdrawal form': '\u64a4\u9500\u7533\u8bf7\u8868',
      '1 · Details': '1 · \u8d44\u6599',
      '1 Â· Details': '1 · \u8d44\u6599',
      '2 · Items': '2 · \u5546\u54c1',
      '2 Â· Items': '2 · \u5546\u54c1',
      '3 · Confirmed': '3 · \u5df2\u786e\u8ba4',
      '3 Â· Confirmed': '3 · \u5df2\u786e\u8ba4',
      'Your details': '\u60a8\u7684\u8d44\u6599',
      'Please enter your email and order number. The merchant uses this data for manual matching.': '\u8bf7\u8f93\u5165\u60a8\u7684\u7535\u5b50\u90ae\u7bb1\u53ca\u8ba2\u5355\u7f16\u53f7\u3002\u5546\u6237\u4f1a\u4f7f\u7528\u8fd9\u4e9b\u8d44\u6599\u4f5c\u4eba\u5de5\u6838\u5bf9\u3002',
      'Name': '\u59d3\u540d',
      'Optional: your name': '\u9009\u586b\uff1a\u60a8\u7684\u59d3\u540d',
      'Order number': '\u8ba2\u5355\u7f16\u53f7',
      'Required field. Please enter the order number as shown in your confirmation.': '\u5fc5\u586b\u5b57\u6bb5\u3002\u8bf7\u8f93\u5165\u786e\u8ba4\u901a\u77e5\u4e2d\u663e\u793a\u7684\u8ba2\u5355\u7f16\u53f7\u3002',
      'Email': '\u7535\u5b50\u90ae\u7bb1',
      'Your confirmation will be sent to this address.': '\u786e\u8ba4\u901a\u77e5\u5c06\u53d1\u9001\u81f3\u6b64\u7535\u5b50\u90ae\u7bb1\u3002',
      'Our Privacy Policy applies.': '\u6211\u4eec\u7684\u9690\u79c1\u653f\u7b56\u9002\u7528\u3002',
      'Privacy Policy': '\u9690\u79c1\u653f\u7b56',
      'Continue': '\u7ee7\u7eed'
    };
    replaceTextNodes(document.body, kind === 'tc' ? tc : sc);

    document.querySelectorAll('input[placeholder]').forEach(function (input) {
      if (input.placeholder === 'Optional: your name') input.placeholder = kind === 'tc' ? '\u9078\u586b\uff1a\u60a8\u7684\u59d3\u540d' : '\u9009\u586b\uff1a\u60a8\u7684\u59d3\u540d';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    repairRichTextJson(document);
    repairFooterLinks();
    removeDuplicateWithdrawalContent();
    localizeWithdrawalForm();
    localizeInternalLinks();
  });
})();
